// extracted by mini-css-extract-plugin
export default {"versionCheckerModal":"VersionChecker_versionCheckerModal__Atblr"};